<template>
  <a-row :gutter="16">
    <a-col :span="24">
      <a-card title="Plafon Kesehatan">
        <a-table :columns="columns" :data-source="listData" bordered style="margin-top: 10px;"
        :pagination="pagination" 
        :scroll="widthScreen < 400 ? { x: 1200, y:500} : { x: 1000 }"
        :loading="loading.table" size="small"
        key="jns_member" :rowKey="(record, index) => {return index;}"
        >
        <template v-for="col in columns" :slot="col.scopedSlots.customRender" slot-scope="text, record, index">
          <span v-if="col.format === 'rupiah'">
            {{ formatRupiah(text) }}
          </span>
          <span v-else-if="col.dataIndex === 'no'">
            {{ index + 1 }}
          </span>
          <div v-else-if="col.dataIndex === 'action'">
            <a-button shape="circle" icon="edit" @click="editPlafon(record)"/>
          </div>
          <span v-else>
            {{ text }}
          </span>
        </template>
        </a-table>
      </a-card>
    </a-col>
    <a-col :span="24" style="margin-top:16px;">
      <a-card title="History Klaim Kesehatan">
        <a-list item-layout="vertical" size="large" :pagination="paginationList" :data-source="listHistory">
          <a-list-item slot="renderItem" key="item.no_klaim" slot-scope="item, index">
            <a-row :gutter="24" style="padding: 10px 0 16px 0;">
              <a-col :span="24">
                <h4 style="font-size: 16px; color: #2a2e2b;">{{ item.no_klaim }}</h4>
              </a-col>
              <a-col :lg="12" :xs="24">
                <div class="card-content">
                  <div class="title">Tanggal transaksi :</div>
                  <div class="value">{{ item.create_dt }}</div>
                </div>
                <div class="card-content">
                  <div class="title">Total Klaim :</div>
                  <div class="value">{{ formatRupiah(item.total_klaim) }}</div>
                </div>
                <div class="card-content">
                  <div class="title">Pembuat :</div>
                  <div class="value">{{ item.tlc_create }}</div>
                </div>
                <div class="card-content">
                  <div class="title">Anggota Keluarga :</div>
                  <div class="value">{{ item.id_member ? item.nama_member+` (${item.jns_member})` : item.nama+ ` (Pribadi/Karyawan)` }}</div>
                </div>
              </a-col>
              <a-col :lg="12" :xs="24">
                <div 
                  v-for="(value, index) in JSON.parse(item.details)" 
                  :key="index"
                  :class="'card-content ' + (index === JSON.parse(item.details).length - 1 ? 'border-bottom' : '')"
                >
                  <div class="title">{{ value.plafon }} :</div>
                  <div class="value">{{ formatRupiah(value.nilai_klaim_appr) }}</div>
                </div>
                <div class="card-content">
                  <div class="title">Total Klaim Bayar :</div>
                  <div class="value" style="font-weight: bold;">{{ formatRupiah(item.total_nilai_klaim_appr) }}</div>
                </div>
                <div class="card-content">
                  <a-tag color="green" v-if="false">
                    Sudah direkap HRD
                  </a-tag>
                </div>
              </a-col>
            </a-row>

          </a-list-item>
        </a-list>
      </a-card>
    </a-col>

    <a-modal :key="stateEdit.modal_key" destroyOnClose v-model="modal_edit" title="Edit Plafon Kesehatan" @cancel="cancelForm">
      <a-row :gutter="8">
        <a-col :span="24">
          <div>
            <span class="list-title" for>Nama Anggota</span>
            <span class="list-desc">{{ stateEdit.data.nama }}</span>
          </div>
        </a-col>
      </a-row>
      <a-divider></a-divider>

      <a-form class="m-form" :form="form">
        <a-row :gutter="8">
          <a-col v-for="value in listForm" :xs="24" :lg="12">
            <a-form-item :label="value.option">
              <a-input-number :id="value.key" :min="1"
              :formatter="rupiahFormatter"
              :parser="rupiahParser"
              class="w-full" 
                v-decorator="[
                    value.key,
                    { 
                      rules: [{ required: true,message: value.option + ' is required!' }],
                      initialValue: value.nominal 
                    }
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <template slot="footer">
        <a-button key="back" @click="cancelForm">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading.submit" @click="handleSubmit">Update</a-button>
      </template>
    </a-modal>

  </a-row>
</template>

<script>
import { mapGetters } from 'vuex';
import CurrencyFormat from "@/mixins/CurrencyFormat";

const columns = [
  {
    title: 'No',
    dataIndex: 'no',
    width: 40,
    className: 'center',
    scopedSlots: { customRender: 'no' },
  },
  {
    title: 'Nama',
    dataIndex: 'nama',
    scopedSlots: { customRender: 'nama' },
  },
  {
    title: 'Status Hubungan Keluarga',
    dataIndex: 'jns_member',
    className: 'center',
    scopedSlots: { customRender: 'jns_member' },
  }
];
export default {
  mixins: [CurrencyFormat],
  props: ["tlc"],
  data(){
    return {
      columns,
      widthScreen: 0,
      heighScreen: 0,
      pagination: {},
      paginationList: {},
      listData: [],
      listHistory: [],
      listPlafon: [],
      listForm: [],
      loading: {
        table: false,
        submit: false
      },
      modal_edit: false,
      stateEdit: {
        id: '',
        data: {},
        modal_key: 0
      }
    }
  },
  mounted(){
    this.widthScreen = window.innerWidth
    this.heighScreen = window.innerHeight
    this.getDataPlafon()
    console.log(this.tlc);
    
  },

  beforeCreate(){
    this.form = this.$form.createForm(this);
  },

  computed: {
    ...mapGetters(["getDefaultDateFormat", "getMaster", "getAuth"])
  },

  methods: {
    async getDataPlafon(){
      this.loading.table = true
      try {
        const payload = {
          tlc: this.tlc,
          tlc_login: this.getAuth.username
        }
        const response = await this.asyncAxiosGet("klaim_kesehatan/plafon_kesehatan", this.getAuth, payload)
        this.listData = response.data 
        this.listHistory = response.history
        this.listPlafon = response.list

        response.list.forEach(d => {
          const columns = {
            title: d.option,
            dataIndex: d.key,
            className: 'center',
            scopedSlots: { customRender: d.key },
            format: 'rupiah'
          }

          const index = this.columns.findIndex(c => c.dataIndex === d.key)
          if (index !== -1) {
            this.columns[index] = { ...columns }
          } else {
            this.columns.push({ ...columns })
          }
        })

        if(this.getAuth.divisi[0] == 'HRD'){
          const actions_column = {
            title: 'Action',
            dataIndex: 'action',
            width: 80,
            className: 'center',
            scopedSlots: { customRender: 'action' }
          }
          const index = this.columns.findIndex(c => c.dataIndex === 'action')
          if (index !== -1) {
            this.columns[index] = { ...actions_column }
          } else {
            this.columns.push({ ...actions_column })
          }
        }
        this.loading.table = false
      } catch (error) {
        this.loading.table = false
        console.log(error);
      }
    },

    rupiahFormatter(value) {
      if (value === undefined || value === null || value === '') return ''
      const num = String(value).replace(/\D/g, '')
      if (!num) return ''
      return 'Rp ' + num.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    rupiahParser(displayValue) {
      if (!displayValue && displayValue !== 0) return undefined
      const digits = String(displayValue).replace(/\D/g, '')
      return digits === '' ? undefined : Number(digits)
    },

    async editPlafon(item){
      this.modal_edit = true
      this.stateEdit.id = item.tlc
      this.stateEdit.data = item
      this.listForm = []
      console.log(item);
      

      if(item.jns_member == 'Istri'){
        this.listPlafon.forEach(e => {
          if(e.key !== 'rawat_gigi'){
            const payload = {...e}
            payload.nominal = item[e.key]

            const index = this.listForm.findIndex(f => f.key === e.key)
            if (index !== -1) {
              this.listForm.splice(index, 1, payload)
            } else {
              this.listForm.push(payload)
            }
          }
        });
      } else if(item.jns_member == 'All'){
        this.listPlafon.forEach(e => {
          if(e.key == 'rawat_gigi'){
            const payload = {...e}
            payload.nominal = item[e.key]

            const index = this.listForm.findIndex(f => f.key === e.key)
            if (index !== -1) {
              this.listForm.splice(index, 1, payload)
            } else {
              this.listForm.push(payload)
            }
          }
        });
      } else if(item.jns_member && item.jns_member.toLowerCase().includes('anak')){
        this.listPlafon.forEach(e => {
          if(e.key == 'rawat_jalan'){
            const payload = {...e}
            payload.nominal = item[e.key]

            const index = this.listForm.findIndex(f => f.key === e.key)
            if (index !== -1) {
              this.listForm.splice(index, 1, payload)
            } else {
              this.listForm.push(payload)
            }
          }
        });
      } else if(item.jns_member && item.jns_member.toLowerCase().includes('suami')){
        this.listPlafon.forEach(e => {
          if(e.key == 'rawat_jalan'){
            const payload = {...e}
            payload.nominal = item[e.key]

            const index = this.listForm.findIndex(f => f.key === e.key)
            if (index !== -1) {
              this.listForm.splice(index, 1, payload)
            } else {
              this.listForm.push(payload)
            }
          }
        });
      } else if(item.jns_member && item.jns_member == 'Pribadi'){
        if(item.gender == 'perempuan'){
          this.listPlafon.forEach(e => {
            if(e.key !== 'rawat_gigi'){
              const payload = {...e}
              payload.nominal = item[e.key]

              const index = this.listForm.findIndex(f => f.key === e.key)
              if (index !== -1) {
                this.listForm.splice(index, 1, payload)
              } else {
                this.listForm.push(payload)
              }
            }
          });
        }else {
          this.listPlafon.forEach(e => {
            if(e.key == 'rawat_jalan'){
              const payload = {...e}
              payload.nominal = item[e.key]

              const index = this.listForm.findIndex(f => f.key === e.key)
              if (index !== -1) {
                this.listForm.splice(index, 1, payload)
              } else {
                this.listForm.push(payload)
              }
            }
          });
        }
      }
    },

    cancelForm(){
      this.modal_edit = false
    },

    handleSubmit(){
      this.loading.submit = true

      this.form.validateFields( async (err, values) => {
        console.log(values);
        console.log(this.stateEdit.data);
        if(err){
          this.displayMessage("form-warning");
          this.loading.submit = false
          return;
        }

        try {
          const payload = {
            tlc: this.tlc,
            id_member: this.stateEdit.data.id,
            jns_member: this.stateEdit.data.jns_member,
            gender: this.stateEdit.data.gender,
            plafon: [{...values}]
          }

          const response = await this.asyncAxiosPost("klaim_kesehatan/update_plafon_kesehatan", 'json', this.getAuth, payload)
          this.getDataPlafon()
          this.displayMessageValue("success-basic", "Data plafon berhasil diubah");
          this.cancelForm()
          this.loading.submit = false
        } catch (error) {
          console.log(error);
          this.loading.submit = false
        }
        
      })
    }

  }
}
</script>

<style>
  .card-content {
    display: flex; 
    justify-content: space-between;
  }

  .card-content .title {
    font-weight: bold;
    flex-shrink: 0;   /* jangan diperkecil */
    flex-grow: 0;     /* jangan diperbesar */
  }

  .card-content .value {
    margin-left: auto;   /* ini bikin dia nempel ke kanan */
    text-align: right;   /* teks di dalam ikut rata kanan */
  }

  .border-bottom {
    border-bottom: 1px solid gray !important;
  }
</style>